import { Component, Input, OnInit } from "@angular/core";
import { TooltipPosition } from "@angular/material/tooltip";
import { NotifyService } from "@core/services/notify.service";
import { DownloadFileService } from "@core/services/download-file.service";
import { TranslateService } from "@ngx-translate/core";
import { TemplateDownloadOption } from "../download-upload.types";
import { DownloadUploadService } from "../download-upload.service";

@Component({
  selector: "app-driveb-template-download-file",
  templateUrl: "./template-download-file.component.html",
  styleUrls: ["./template-download-file.component.scss"],
  standalone: false
})
export class TemplateDownloadFileComponent implements OnInit {
  @Input() options: TemplateDownloadOption[] = [];
  @Input() positionTooltip: TooltipPosition = "right";
  @Input() disabled = false;
  @Input("tooltip") tooltipValue = "";

  fontIcon = "Bosch-Ic-download";

  constructor(
    private translateService: TranslateService,
    private downloadFileService: DownloadFileService,
    private downloadUploadService: DownloadUploadService,
    private notifyService: NotifyService
  ) {}

  ngOnInit(): void {
    this.setDefaultTooltip();
  }

  setDefaultTooltip(): void {
    if (!this.tooltipValue) {
      this.tooltipValue = this.translateService.instant(
        "download-upload-file.download-template"
      );
    }
  }

  downloadTemplate(option: TemplateDownloadOption): void {
    if (option.endpoint) {
      this.downloadTemplateFromEndpoint(option);
      return;
    }

    if (!option.path) {
      return;
    }

    this.downloadFileService.downloadFromUrl(
      option.path,
      this.getFileName(option)
    );
  }

  private downloadTemplateFromEndpoint(option: TemplateDownloadOption): void {
    this.downloadUploadService
      .getFileData(option.endpoint, option.requestBody)
      .subscribe(
        (response) => {
          if (response.body) {
            this.downloadFileService.downloadFile(
              response.body,
              this.getFileName(option)
            );
          }
        },
        () => {
          this.notifyService.showErrorMessage(
            this.translateService.instant("default-error-message")
          );
        }
      );
  }

  private getFileName(option: TemplateDownloadOption): string {
    if (option.fileName) {
      return option.fileName;
    }

    if (option.path) {
      return this.getFileNameFromPath(option.path);
    }

    return "template.xlsx";
  }

  private getFileNameFromPath(path: string): string {
    const normalizedPath = path.split(/[?#]/)[0];
    return normalizedPath.split("/").pop() || "template";
  }
}
